import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { TempModalCadastroComponent } from '../../../shared/templates/temp-modal-cadastro/temp-modal-cadastro.component';
import { MessageService, UnidadesEmpresaService } from '@services';
import { ParametrosGeraisViewModel } from '../../../model/ParametrosGeraisViewModel';
import { AlmoxarifadosService } from '../../../services/almoxarifados.service';
import { ItensService } from '../../../services/itens.service';
import { NFEntradaService } from '../../../services/nfentrada.service';
import { UnidadesEmpresaParametrosService } from '../../../services/unidades-empresa-parametros.service';
import { UnidadesMedidaService } from '../../../services/unidades-medida.service';
import { UnidadesMedidaViewModel } from 'models/unidades-medida/UnidadesMedidaViewModel';
import ItemFornecedor from '../../../model/ItemFornecedorViewModel';
import { TipoItensService } from '../../../services/tipo-itens.service';
import { IAliquotaICMS } from '../../../model/IAliquotaICMS';
import { OrigemMercadoria } from '../../../model/OrigemMercadoria';
import { TipoSituacaoTributariaIPI } from '../../../model/TipoSituacaoTributariaIPI';
import { TipoSituacaoTributariaPIS } from '../../../model/TipoSituacaoTributariaPIS';
import { TipoSituacaoTributariaCOFINS } from '../../../model/TipoSituacaoTributariaCOFINS';
import { TipoCodigosProdutosANP } from '../../../model/TipoCodigosProdutosANP';
import { CodigosBeneficiosFiscaisService } from '../../../services/codigos-beneficios-fiscais.service';
import { TipoDestaqueICMS } from '../../../model/TipoDestaqueICMS';
import { AliquotasIcmsService } from '../../../services/aliquotasIcms.service';
import { AbrirModalComponent } from '../../../shared/abrir-modal/abrir-modal.component';
import { lastValueFrom } from 'rxjs';
import { ConfigurarDadosNfeVendaViewModel } from '../../../model/ConverterNotasFiscaisEntradaItensViewModel';
import { AliquotasPISCOFINSViewModel } from '../../../model/AliquotasPISCOFINSViewModel';

@Component({
  selector: 'app-cadastro-itens-manifesto',
  templateUrl: './cadastro-itens-manifesto.component.html',
  styleUrls: ['./cadastro-itens-manifesto.component.css']
})
export class CadastroItensManifestoComponent extends ModalCadastroComponent implements OnInit {

  constructor(
    private nfeEntradaService: NFEntradaService,
    private itensService: ItensService,
    private messageService: MessageService,
    private almoxarifadoService: AlmoxarifadosService,
    private unidadesMedidaService: UnidadesMedidaService,
    private parametrosService: UnidadesEmpresaParametrosService,
    private unidadesEmpresaService: UnidadesEmpresaService,
    private tiposItensService: TipoItensService,
    private codigosBeneficiosFiscaisService: CodigosBeneficiosFiscaisService,
    private aliquotasIcmsService: AliquotasIcmsService
  ) { super(); }


  @ViewChild('modalCadastro', { static: true }) modalCadastro: TempModalCadastroComponent;
  @ViewChild('abrirModal', { static: true }) abrirModal: AbrirModalComponent;
  itens: RetornoBuscarItensFornecedoresViewModel[];

  loadingData = false;
  loading = false;
  almoxarifados: any[];
  almoxarifadoPadraoId: number;
  unidadesMedida: UnidadesMedidaViewModel[];
  movimentarEstoque = false;
  naoVincularItens = false;
  unidadeEmpresa = null;
  aliquotasPisCofins: AliquotasPISCOFINSViewModel = null;
  parametrosGerais: ParametrosGeraisViewModel = null;

  form: FormGroup;
  tipoAtribuicao: 'todos' | 'ncm' = 'todos';
  ncms: string[] = [];
  ncmSelecionado: string = '';
  dadosPorNcm: { [key: string]: any } = {};
  dadosTodos: any = {};

  tipoItens: any[] = [];
  aliquotas: IAliquotaICMS[] = [];
  aliquotasSelecionadas: IAliquotaICMS[] = [];
  origens: any[] = new OrigemMercadoria().ListarOrigem();
  situacaoTributariaIPI: any[] = this.mapTipoDescricao(new TipoSituacaoTributariaIPI().Listar(), true);
  situacaoTributariaPis: any[] = this.mapTipoDescricao(new TipoSituacaoTributariaPIS().List(), true);
  situacaoTributariaCofins: any[] = this.mapTipoDescricao(new TipoSituacaoTributariaCOFINS().Listar(), true);
  tipoProdutoANPMap: any[] = this.mapTipoDescricao(new TipoCodigosProdutosANP().listar());
  codigosCreditoPresumido: any[] = [];


  ngOnInit() {
    const ID = this.prop?.['ID'];
    if (!ID) return;

    this.carregarDados(ID);
  }

  async carregarDados(ID: number) {
    this.loading = true;
    this.loadingData = true;

    try {
      this.createForm();

      const [
        unidade,
        aliquotasPC,
        itensRes,
        parametros
      ] = await Promise.all([
        lastValueFrom(this.unidadesEmpresaService.getUnidadeEmpresa()),
        lastValueFrom(this.itensService.buscarAliquotasPISCOFINS()),
        lastValueFrom(this.nfeEntradaService.buscarItensFornecedores(ID)),
        lastValueFrom(this.parametrosService.getParametrosGerais()),

        this.carregaAlmoxarifados(),
        this.carregaUnidadesMedida(),
        this.carregaTipoItens(),
        this.carregaAliquotaIcms(),
        this.carregaCodigoCreditoPresumido()
      ]);

      this.unidadeEmpresa = unidade;
      this.aliquotasPisCofins = aliquotasPC;
      this.parametrosGerais = parametros;

      if (parametros?.almoxarifadoPadraoId) {
        this.almoxarifadoPadraoId = parametros.almoxarifadoPadraoId;
      }

      this.itens = (itensRes as any[]).map(i => {
        i.quantidadeEstoque = i.quantidade;
        if (i.itemFornecedor.itemID) {
          i.unidadeMedidaID = i.itemFornecedor.item.unidadeMedidaID;
          i.precoVenda = i.itemFornecedor.item.precoSaida;
        } else {
          i.nome = i.itemFornecedor.nome;
        }
        return i;
      });

      this.ncms = [...new Set(this.itens.map(i => i.classificacaoFiscalDesc))].filter(n => n);
      if (this.ncms.length > 0) {
        this.ncmSelecionado = this.ncms[0];
      }

      // Inicializa o formulário com os defaults inteligentes baseados no primeiro item
      const firstItem = this.itens[0];
      const defaults = this.formDefaultValues(firstItem);
      this.form.patchValue(defaults, { emitEvent: true });

      // Se for por NCM, inicializamos o dicionário para cada NCM com os dados do seu primeiro item
      if (this.tipoAtribuicao === 'ncm') {
        this.ncms.forEach(ncm => {
          const itemNcm = this.itens.find(i => i.classificacaoFiscalDesc === ncm);
          this.dadosPorNcm[ncm] = this.formDefaultValues(itemNcm);
        });

        if (this.ncmSelecionado) {
          this.form.patchValue(this.dadosPorNcm[this.ncmSelecionado], { emitEvent: false });
        }
      } else {
        this.dadosTodos = { ...this.form.value };
      }
    } catch (error) {
      console.error(error);
      this.messageService.error('Ocorreu um erro ao carregar os dados.');
    } finally {
      this.loading = false;
      this.loadingData = false;
    }
  }

  createForm() {
    this.form = new FormGroup({
      tipoItemid: new FormControl(null),
      substituicaoTributaria: new FormControl(false),
      abaterICMSBasePISCOFINS: new FormControl(false),
      aliquotaicmsid: new FormControl(null),
      codigoANP: new FormControl(null),
      origemMercadoria: new FormControl(null),
      tipoDestaqueICMS: new FormControl(TipoDestaqueICMS.NORMAL),
      codigoBeneficioFiscal: new FormControl(null),
      cCredPresumido: new FormControl(null),
      pCredPresumido: new FormControl(null),
      percentualDiferimento: new FormControl(null),
      destacarICMSItemDiferido: new FormControl(false),
      ipiSituacaoTributaria: new FormControl(null),
      aliquotaipi: new FormControl(null),
      pisSituacaoTributaria: new FormControl(null),
      pis: new FormControl(null),
      cofinsSituacaoTributaria: new FormControl(null),
      cofins: new FormControl(null)
    });

    this.form.valueChanges.subscribe(val => {
      if (this.tipoAtribuicao === 'todos') {
        this.dadosTodos = val;
        return;
      }
      this.dadosPorNcm[this.ncmSelecionado] = val;
    });
  }

  async carregaTipoItens() {
    this.tipoItens = await lastValueFrom(this.tiposItensService.get());
  }

  async carregaAliquotaIcms() {
    const res = await lastValueFrom(this.aliquotasIcmsService.getAliquotasIcms());
    this.aliquotas = res;
    this.aliquotasSelecionadas = res;
  }

  async carregaAlmoxarifados() {
    this.almoxarifados = await lastValueFrom(this.almoxarifadoService.get());
  }

  async carregaUnidadesMedida() {
    this.unidadesMedida = await lastValueFrom(this.unidadesMedidaService.get());
  }

  async carregaCodigoCreditoPresumido() {
    this.codigosCreditoPresumido = await lastValueFrom(this.codigosBeneficiosFiscaisService.getCreditoPresumido());
  }

  mapTipoDescricao(situacoes, removeId = false) {
    return situacoes.map(element => {
      if (removeId) {
        return { id: element.tipo, name: element.descricao };
      }
      return { id: element.tipo, name: element.tipo + ' - ' + element.descricao };
    });
  }

  setTipoAtribuicao(tipo: 'todos' | 'ncm') {
    this.tipoAtribuicao = tipo;
    if (tipo === 'todos') {
      this.form.patchValue(this.dadosTodos, { emitEvent: false });
      return;
    }
    this.setNcmSelecionado(this.ncmSelecionado);
  }

  setNcmSelecionado(ncm: string) {
    this.ncmSelecionado = ncm;
    const dados = this.dadosPorNcm[ncm] || this.formDefaultValues();
    this.form.patchValue(dados, { emitEvent: false });
  }

  formDefaultValues(item?: any) {
    const isSimples = [1, 4].includes(this.unidadeEmpresa?.crt);

    let aliqIcmsId = this.parametrosGerais?.aliquotaIcmsPadraoId || null;
    if (item?.aliquotaICMS) {
      const match = this.aliquotas.find(a => a.aliquotaICMS === item.aliquotaICMS);
      if (match) aliqIcmsId = match.id;
    }

    return {
      tipoItemid: 1, // Mercadoria para Revenda
      substituicaoTributaria: (item?.stVenda && ['10', '30', '60', '70', '201', '202', '203', '500'].includes(item.stVenda)) || false,
      abaterICMSBasePISCOFINS: false,
      aliquotaicmsid: aliqIcmsId,
      codigoANP: item?.itemFornecedor?.codigoANP || null,
      origemMercadoria: item?.origemMercadoria ?? 0,
      tipoDestaqueICMS: TipoDestaqueICMS.NORMAL,
      codigoBeneficioFiscal: null,
      cCredPresumido: null,
      pCredPresumido: null,
      percentualDiferimento: null,
      destacarICMSItemDiferido: false,
      ipiSituacaoTributaria: item?.stVendaIPI || '52', // Saída Isenta
      aliquotaipi: item?.aliquotaIPI || null,
      pisSituacaoTributaria: isSimples ? '99' : (item?.stVendaPIS || '01'),
      pis: isSimples ? 0 : (item?.aliquotaPIS ?? this.aliquotasPisCofins?.aliquotaPIS ?? 0),
      cofinsSituacaoTributaria: isSimples ? '99' : (item?.stVendaCOFINS || '01'),
      cofins: isSimples ? 0 : (item?.aliquotaCOFINS ?? this.aliquotasPisCofins?.aliquotaCOFINS ?? 0)
    };
  }

  aliquotaIcmsSelectLabel(item: IAliquotaICMS) {
    if ((item.percentualRedutorICMS || 0) > 0) {
      return `${item.aliquotaICMS}% - Redução ${item.percentualRedutorICMS || 0}%`;
    }
    return `${item.aliquotaICMS}%`;
  }

  get estadoEmpresa() {
    if (!this.unidadeEmpresa) return null;
    return this.unidadeEmpresa.cidade.estado.siglaEstado;
  }

  get customDataCBenef() {
    if (!this.unidadeEmpresa) return null;

    if ([1, 4].includes(this.unidadeEmpresa.crt)) {
      return { cst: 'SIMPLES' };
    }

    const csts = {
      [TipoDestaqueICMS.NORMAL]: null,
      [TipoDestaqueICMS.ISENTO]: '40',
      [TipoDestaqueICMS.NAO_TRIBUTADO]: '41',
      [TipoDestaqueICMS.SUSPENSO]: '50',
      [TipoDestaqueICMS.DIFERIDO]: '51',
    };

    const cst = csts[this.form.get('tipoDestaqueICMS').value] || null;
    return { cst: cst };
  }

  aplicar() {
    const manifestoID = this.prop?.['ID'];
    if (!manifestoID) return;

    const payload: ConfigurarDadosNfeVendaViewModel = {
      manifestoID: manifestoID,
      tipoAtribuicao: this.tipoAtribuicao,
      dadosTodos: this.dadosTodos,
      dadosPorNcm: this.dadosPorNcm
    };

    this.abrirModal.abrir('itensManifesto', { ID: manifestoID, configuracao: payload });
  }

  onChildModalClosed(success: boolean) {
    if (success) {
      this.modalCadastro.hide();
      this.closed.emit(true);
    }
  }

  destroyComponent() {
    this.closed.emit();
  }

  show() {
    this.modalCadastro.show();
  }

}

interface RetornoBuscarItensFornecedoresViewModel {
  id: number;
  itemFornecedorID: number;
  itemFornecedor: ItemFornecedor;
  quantidade: number;
  custoEntrada: number;
  precoVenda: number;
  unidadeMedidaID: number;
  movimentouEstoque: boolean;
  aliquotaIPI: number;
  classificacaoFiscalDesc: string;

  selecionado: boolean;
  quantidadeEstoque: number;
  nome: string;
  codigo: string;
  novoItemID: number;
  validade: Date;
}